import React from 'react';
import facilityContent from '../data/people-content'



const Person = ({ name }) => {
    const profile = facilityContent.find(person => person.name === name);
    if (!profile) return <h1>No such person</h1>
    return (
    <>
        <div className="personBlock">
        <p><a href={profile.headShot}>
        <img class="alignnone wp-image-150 alignleft" src={profile.headShot} alt="" width="150" height="170" sizes="(max-width: 150px) 100vw, 150px" />
        </a></p>
        <p className="paragraphContent" dangerouslySetInnerHTML={{__html: profile.description}}>{}</p>
        <p className="paragraphContent" dangerouslySetInnerHTML={{__html: profile.link}}>{}</p>
        </div>
    </> 
    );
};

export default Person;